var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuoteBottom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 41,
    viewBox: "0 0 49 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.057 40.7143L29.5143 37.4935C33.2436 35.0074 36.0123 32.4082 37.8204 29.696C39.5155 27.0968 40.3631 24.6671 40.3631 22.407C40.3631 20.2598 39.0635 18.8472 36.4643 18.1692C34.2042 17.7171 32.283 16.7001 30.7009 15.118C29.1188 13.6489 28.3278 11.6147 28.3278 9.01555C28.3278 6.41637 29.2318 4.26921 31.0399 2.57409C32.8481 0.878974 34.8822 0.0314158 37.1424 0.0314158C39.9676 0.0314158 42.5102 1.10499 44.7704 3.25214C47.0306 5.39929 48.1606 9.01554 48.1606 14.1009C48.1606 18.7342 46.8611 23.424 44.2619 28.1704C41.5497 33.0297 37.4814 37.211 32.057 40.7143ZM3.91806 40.7143L1.37538 37.4935C5.10464 35.0074 7.87333 32.4082 9.68146 29.696C11.3766 27.0968 12.2241 24.6671 12.2241 22.407C12.2241 20.2598 10.9245 18.8472 8.32536 18.1692C6.06521 17.7171 4.14408 16.7001 2.56197 15.118C0.979852 13.6489 0.188795 11.6147 0.188795 9.01555C0.188795 6.41637 1.09286 4.26921 2.90098 2.57409C4.70911 0.878974 6.74325 0.0314158 9.00341 0.0314158C11.8286 0.0314158 14.3713 1.10499 16.6314 3.25214C18.8916 5.39929 20.0217 9.01554 20.0217 14.1009C20.0217 18.7342 18.7221 23.424 16.1229 28.1704C13.4107 33.0297 9.34244 37.211 3.91806 40.7143Z",
    fill: "#142943"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuoteBottom);
export default __webpack_public_path__ + "static/media/QuoteBottom.47bfce7cabd5f4cf2b77a5ee997900b3.svg";
export { ForwardRef as ReactComponent };